"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PointerStateStatic = /** @class */ (function () {
    function PointerStateStatic() {
        this.multiplierX = -1;
        this.multiplierY = -1;
    }
    return PointerStateStatic;
}());
exports.default = PointerStateStatic;
//# sourceMappingURL=PointerStateStatic.js.map